import { SelectBoxMulti } from '@core/components/SelectBoxMulti/SelectBoxMulti';
import {
  Category,
  photosState,
  setSelectedCategories,
} from '@photos/components/PhotosInViewport/state';
import { useSnapshot } from 'valtio';

export const PhotosCategory = () => {
  const { showPhotos, possibleCategories, selectedCategories } = useSnapshot(photosState);

  return (
    <SelectBoxMulti<Category>
      label="Photo category"
      availableItems={possibleCategories as Category[]}
      items={selectedCategories as Category[]}
      setItems={setSelectedCategories}
      disabled={!showPhotos}
    />
  );
};
